module.exports = __webpack_public_path__ + "static/media/orders.a15fb36a.svg";